import { render, staticRenderFns } from "./intermediateWx.vue?vue&type=template&id=2ec33774&scoped=true&"
import script from "./intermediateWx.vue?vue&type=script&lang=js&"
export * from "./intermediateWx.vue?vue&type=script&lang=js&"
import style0 from "./intermediateWx.vue?vue&type=style&index=0&id=2ec33774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec33774",
  null
  
)

export default component.exports